import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../index';
import { basicMutationOnCompleted, onErrorMutation } from '../common/common';

const mutation = graphql`
    mutation UpdateTeamNameMutation($name: String!) {
      updateTeamName(name: $name) {
        ok
        error
      }
    }
  `;

export default ({ name }, done) => {
  const variables = { name };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ updateTeamName }) => basicMutationOnCompleted(updateTeamName, done),
      onError: error => onErrorMutation(error, done),
      updater: (store) => {
        const root = store.getRoot();
        const userTeamRecord = root.getLinkedRecord('userTeam');
        if (userTeamRecord) {
          userTeamRecord.setValue(name, 'name');

          const userTeamId = userTeamRecord.getValue('teamId');
          const userTeamApiKey = userTeamRecord.getValue('apiKey');
          const teamsRecords = root.getLinkedRecords('teams') || [];

          teamsRecords.forEach((teamRecord) => {
            const teamId = teamRecord.getValue('id');
            const teamApiKey = teamRecord.getValue('apiKey');
            if (teamId === userTeamId || (userTeamApiKey && teamApiKey === userTeamApiKey)) {
              teamRecord.setValue(name, 'name');
            }
          });
        }
      }
    }
  );
};
